import { cmsAxiosInstance } from 'api/axiosClient'
import { getPageSEO } from 'helpers/seo'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'

import dynamic from 'next/dynamic'

const PartnersPage = dynamic(() =>
  import('containers/PublicPages/PartnersPage').then((res) => res.PartnersPage)
)

export default withAuth(PartnersPage, {
  LoggedOutComponent: PartnersPage,
  naiveCheck: true,
})

export const getStaticProps = withAuthServerSideProps(async () => {
  const partners =
    (
      await cmsAxiosInstance
        .get('partners')
        .catch(() => ({ data: { data: [] } }))
    ).data?.data || []

  return { ...getPageSEO('partners'), partners }
})
